import React from "react";
import SEO from "../components/SEO";
import { useGallery, GalleryGrid } from "../components/InstallGallery";

export default function RecentInstalls() {
  const items = useGallery();
  return (
    <main data-testid="recent-installs-page" className="section-pad bg-white">
      <SEO title="Recent Installs | Set Up Home Theater, Rocky Mount NC" description="Real before and after photos of TV mounting and home theater installs by Set Up Home Theater. Call (252) 545-0011." path="/recent-installs" />
      <div className="max-w-[1100px] mx-auto px-5 lg:px-8">
        <span className="eyebrow">Recent installs</span>
        <h1 className="mt-3 text-4xl sm:text-5xl font-extrabold text-[#0a1f44]">Recent Installs</h1>
        <p className="mt-3 text-slate-600">Real photos from real jobs. Newest first.</p>
        <div className="mt-10">
          {items === null ? null : items.length === 0
            ? <p data-testid="recent-installs-empty" className="text-slate-500 pb-24">New installs coming soon.</p>
            : <GalleryGrid items={items} />}
        </div>
      </div>
    </main>
  );
}
